import { OptionTitle } from "./OptionTitle"

export const AdoptionPathwayChoices: Array<OptionTitle> = [
  { title: "Domestic", id: "DOMESTIC" },
  { title: "International/intercountry", id: "INTERNATIONAL" },
  { title: "Adopting from foster care", id: "FOSTER" },
  { title: "I'm not sure", id: "NOT_SURE" }
]
